//****************************************
// Legend Helpers Prototype
// DOM Registration: Not an element
// National Instruments Copyright 2015
//****************************************

(function () {
    'use strict';
    // Static Private Reference Aliases
    var NI_SUPPORT = NationalInstruments.HtmlVI.NISupport;

    // Constructor Function
    NationalInstruments.HtmlVI.Elements.LegendHelpers = function (helpers, legendItemDisplay) {
        this.helpers = helpers;
        this.legendItemDisplay = legendItemDisplay;
    };

    // Static Public Variables
    // None

    var child = NationalInstruments.HtmlVI.Elements.LegendHelpers;
    var proto = child.prototype;

    // Static Private Variables
    // None

    // Static Private Functions
    // None

    // Public Prototype Methods
    proto.createJQXButton = function(className, isToggle = false) {
        var button = document.createElement(isToggle ? 'jqx-toggle-button' : 'jqx-button');
        button.className = className;
        button.animation = 'none';
        button.unfocusable = true;
        return button;
    }

    proto.addButtons = function (menuItem, div, index) {
        var that = this;
        var btn, current;
        menuItem.children.forEach(function (children) {
            btn = that.createJQXButton('ni-button', true);
            btn.checked = false;
            if (children.cssClass !== '') {
                btn.classList.add(children.cssClass);
            }

            btn.addEventListener('change', function () {
                if (current === this) {
                    this.checked = true;
                    return;
                }
                if (!this.checked) {
                    return;
                }
                var last = current;
                current = this;
                last.checked = false;

                that.helpers.handleClick(children.name, null, index);
                that.legendItemDisplay.updateShape(index);
            });

            var state = that.helpers.getState(children.name, index);
            if (state !== undefined) {
                btn.checked = state;
                if (state === true) {
                    current = btn;
                }
            }

            div.appendChild(btn);
        });
    };

    proto.addComboBox = function (menuItem, dropdownContainer, index, iconWidth, dropdownClassName) {
        var that = this;
        var i, selectedIndex = 0, init = true;
        var dropdownList = document.createElement('jqx-drop-down-list');
        dropdownContainer.appendChild(dropdownList);
        dropdownContainer.appendChild(dropdownList); // append twice to prevent a bug that make the dropdown content have different width than dropdown header
        dropdownList.itemHeight = 32;
        dropdownList.dropDownHeight = 'auto';
        dropdownList.classList.add(...dropdownClassName.split(' '));
        for (i = 0; i < menuItem.children.length; i++) {
            var text = NI_SUPPORT.i18n(menuItem.children[i].tag);
            if (text.substring(0, 5) === '[msg_') { // in case server is not running
                text = menuItem.name;
            }

            var dropdownItemContent = `<label class="ni-selector-title">${text}</label><icon class="ni-selector-icon ${menuItem.children[i].cssClass}" style="background-size: ${iconWidth}px 16px; width: ${iconWidth + 4}px; "></icon>`;
            dropdownList.insert(i, dropdownItemContent);
            var itemState = this.helpers.getState(menuItem.children[i].name, index);
            if (itemState === true) {
                selectedIndex = i;
            }
        }

        dropdownList.addEventListener('change', function (event) {
            if (init === true) {
                return;
            }

            that.helpers.handleClick(menuItem.children[event.detail.index].name, null, index);
            that.legendItemDisplay.updateShape(index);
        });

        dropdownList.selectedIndexes = [selectedIndex];
        init = false;
    };

    proto.addColorBox = function (menuItem, container, index, className) {
        var that = this;

        var colorPicker = document.createElement('jqx-color-picker');
        colorPicker.style.width = 'inherit';
        colorPicker.animation = 'none';
        colorPicker.displayMode = 'palette';
        colorPicker.valueFormat = 'hex';
        colorPicker.hideContentToFit = [];
        colorPicker.classList.add('legend-colorbox-colorbox');
        colorPicker.classList.add(...className.split(' '));
        container.appendChild(colorPicker);

        var color = that.helpers.getState(menuItem.name, index);
        colorPicker.value = color || '';
        colorPicker.addEventListener('change', function () {
            that.helpers.handleClick(menuItem.name, colorPicker.value, index);
            that.legendItemDisplay.updateShape(index);
        });
    };

    proto.addCheckBox = function (menuItem, container, index, className) {
        var that = this;
        var btn = document.createElement('jqx-check-box');
        btn.animation = 'none';
        btn.unfocusable = true;
        btn.className = className;
        btn.classList.add('legend-checkbox');
        btn.addEventListener('change', function (e) {
            that.helpers.handleClick(menuItem.name, e.detail.value, index);
        });
        container.appendChild(btn);
        var state = that.helpers.getState(menuItem.name, index);
        if (state !== undefined) {
            btn.checked = state;
        }
    };
}());
